module.exports = __webpack_public_path__ + "img/img-8d2f4d.png";